import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c348da9e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "floating_videos_with_sticky_text" };
const _hoisted_2 = {
    key: 0,
    class: "big-static-title"
};
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "col p-0" };
const _hoisted_5 = ["title", "onClick"];
const _hoisted_6 = ["src", "title"];
const _hoisted_7 = ["src", "title", "alt"];
const _hoisted_8 = {
    key: 0,
    class: "floating-video__content"
};
const _hoisted_9 = { class: "floating-video__content--wrapper" };
const _hoisted_10 = { class: "floating-video__content--title" };
const _hoisted_11 = {
    key: 1,
    class: "floating-video__content--description p-large w-100"
};
const _hoisted_12 = { class: "floating-video__content--arrow-wrapper" };
const _hoisted_13 = ["href"];
const _hoisted_14 = {
    key: 0,
    class: "more"
};
const _hoisted_15 = ["href"];
import { onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'floating_videos_with_sticky_text',
    props: ['d'],
    setup(__props) {
        const d = __props;
        const isCategoryScrolledIntoView = ref(new Array(d.d.floating_videos_with_sticky_text_repeatable.length).fill(false));
        const main = ref();
        const bigTextWrapper = ref(null);
        const redirectToCaseStudy = (siteUrl) => {
            window.location.href = siteUrl;
        };
        onMounted(() => {
            const observer = new IntersectionObserver(entries => {
                if (bigTextWrapper.value) {
                    const wrapperHeight = bigTextWrapper.value.offsetHeight;
                    const bottomOfWrapper = bigTextWrapper.value.offsetTop + wrapperHeight;
                    if (entries[0].boundingClientRect.bottom <= bottomOfWrapper) {
                        bigTextWrapper.value.classList.add('stop-sticky');
                    }
                    else {
                        bigTextWrapper.value.classList.remove('stop-sticky');
                    }
                }
            });
            observer.observe(document.body);
            function handleVideoVisibility(entries) {
                entries.forEach(entry => {
                    const iframe = entry.target.querySelector('iframe');
                    try {
                        const vimeoPlayer = new Vimeo.Player(iframe);
                        if (entry.isIntersecting) {
                            vimeoPlayer.play();
                        }
                        else {
                            vimeoPlayer.pause();
                        }
                    }
                    catch (e) {
                        return; // Return if the vimeo instance is not initialised
                    }
                });
            }
            const categoryObservers = [];
            d.d.floating_videos_with_sticky_text_repeatable.forEach((casestudy, index) => {
                const categoryElements = document.querySelectorAll(`.floating-video__content--category`);
                const categoryObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            setTimeout(() => isCategoryScrolledIntoView.value[index] = true, 500);
                        }
                        else {
                            setTimeout(() => isCategoryScrolledIntoView.value[index] = false, 500);
                        }
                    });
                }, { threshold: 1 });
                categoryElements.forEach(element => {
                    categoryObserver.observe(element);
                });
                categoryObservers.push(categoryObserver);
            });
            const videoElements = document.querySelectorAll('.floating-video');
            videoElements.forEach(videoElement => {
                const videoObserver = new IntersectionObserver(handleVideoVisibility, { root: null, threshold: 0, rootMargin: "-40% 0% -40% 0%" }); // Threshold 0.7 means 70% of the video is in the viewport
                videoObserver.observe(videoElement);
            });
        });
        function getDivStyle(vimeo_id, image) {
            let styles = '';
            if (vimeo_id) {
                styles += 'padding: 50% 0 0 0; ';
            }
            styles += `background-image: url(${image}); background-size: cover;`;
            return styles;
        }
        return (_ctx, _cache) => {
            const _component_badge = _resolveComponent("badge");
            const _component_arrow = _resolveComponent("arrow");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (d.d.title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(d.d.title), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    id: "floating-videos",
                    class: _normalizeClass(["container floating-videos", { 'floating-videos__simple': d.d.simpleDesign }]),
                    ref_key: "main",
                    ref: main
                }, [
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.d.floating_videos_with_sticky_text_repeatable, (casestudy, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["row floating-video", { 'floating-video__has-title': d.d.title }]),
                                key: index,
                                style: _normalizeStyle({ paddingTop: index === 0 ? '0' : '3rem' })
                            }, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", {
                                        style: _normalizeStyle([getDivStyle(casestudy.vimeo_id, casestudy.image), { "position": "relative", "cursor": "url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNTZweCIgaGVpZ2h0PSI1N3B4IiB2aWV3Qm94PSIwIDAgNTYgNTciIHZlcnNpb249IjEuMSI+CjxnIGlkPSJzdXJmYWNlMSI+CjxwYXRoIHN0eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDojRkY1MzE3O2ZpbGwtb3BhY2l0eToxOyIgZD0iTSAwLjAzOTA2MjUgMzMuMDg1OTM4IEwgNi45Mjk2ODggMzkuOTI1NzgxIEwgNi45MDIzNDQgMTMuMDkzNzUgTCA1MC44MjgxMjUgNTYuNjgzNTk0IEwgNTYuMDAzOTA2IDUxLjU0Njg3NSBMIDExLjk4NDM3NSA3Ljg2MzI4MSBMIDM5LjIxMDkzOCA3Ljg5MDYyNSBMIDMyLjMyMDMxMiAxLjA1MDc4MSBMIDAuMDA3ODEyNSAxLjAxOTUzMSBaIE0gMC4wMzkwNjI1IDMzLjA4NTkzOCAiLz4KPC9nPgo8L3N2Zz4K'), auto" }]),
                                        title: `Click to view ${casestudy.casestudy_title} - ${casestudy.title}`,
                                        onClick: ($event) => (redirectToCaseStudy(casestudy.alias))
                                    }, [
                                        (d.d.simpleDesign && casestudy.categories)
                                            ? (_openBlock(), _createBlock(_component_badge, {
                                                key: 0,
                                                content: casestudy.categories.map(category => category.title),
                                                isWhite: "true",
                                                isAbsolute: "true",
                                                arrowCursor: "true",
                                                small: "true"
                                            }, null, 8, ["content"]))
                                            : _createCommentVNode("", true),
                                        (casestudy.vimeo_id)
                                            ? (_openBlock(), _createElementBlock("iframe", {
                                                key: 1,
                                                src: `//player.vimeo.com/video/${casestudy.vimeo_id}?background=1&quality=2k`,
                                                frameborder: "0",
                                                allow: "autoplay",
                                                loading: "lazy",
                                                style: { "position": "absolute", "top": "0", "left": "0", "width": "100%", "height": "100%" },
                                                title: casestudy.title
                                            }, null, 8, _hoisted_6))
                                            : _createCommentVNode("", true),
                                        (!casestudy.vimeo_id)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 2,
                                                src: casestudy.image,
                                                title: casestudy.title,
                                                class: "image",
                                                alt: casestudy.title,
                                                loading: "lazy"
                                            }, null, 8, _hoisted_7))
                                            : _createCommentVNode("", true)
                                    ], 12, _hoisted_5),
                                    (!d.d.simpleDesign)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                                (casestudy.categories)
                                                    ? (_openBlock(), _createBlock(_component_badge, {
                                                        key: 0,
                                                        content: casestudy.service ? [casestudy.service] : casestudy.categories.map(category => category.title),
                                                        hasGlimmer: "true",
                                                        isLarge: "true"
                                                    }, null, 8, ["content"]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("h3", _hoisted_10, _toDisplayString(casestudy.title), 1),
                                                (casestudy.description)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(casestudy.description), 1))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createElementVNode("a", {
                                                        class: "no-style",
                                                        href: casestudy.alias
                                                    }, [
                                                        _createVNode(_component_arrow, {
                                                            rotate: "right",
                                                            canHover: "true"
                                                        })
                                                    ], 8, _hoisted_13)
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ], 6));
                        }), 128))
                    ]),
                    ((d.d.show_more_cta == 'true'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("a", {
                                class: "no-style",
                                href: d.d.show_more_link ?? '/work'
                            }, "All Work", 8, _hoisted_15)
                        ]))
                        : _createCommentVNode("", true)
                ], 2)
            ]));
        };
    }
});
